import { useModuleContext } from '../contexts/module'
import { TextLink } from '@mch-group/uikit-components'

const AttachmentsInfo = () => {
  const { state: { attachmentsInformation } } = useModuleContext()
  const attachments = attachmentsInformation || {}
  return (
    <div className='col-12 col-md-6' >
      <div className='mt-8 mt-md-12 mt-lg-8 d-flex flex-column'>
        {Object.keys(attachments).map((item) =>
          (attachments[item].url ?
            <a key={attachments[item].url} title={attachments[item].label} href={attachments[item].url} target='_blank' className='text-link color-black' rel='nofollow noopener'>
              <TextLink
                className='flex-nowrap text-nowrap'
                icon={attachments[item].icon}
              >{attachments[item].label}</TextLink>
            </a> : null))}
      </div>
    </div >)
}

export default AttachmentsInfo
